// Generated by scripts/sync-bindings.ts (bindings.config.ts joined with specs/openapi.json). Do not edit.

import type { FieldCondition, OptionSource } from '../utils/field-schema.js';

/** `METHOD /path` of a bound operation -> request field -> the collection its choices are read from. */
export const OPTION_SOURCES: Record<string, Record<string, OptionSource>> = {
  "GET /angel-numbers/numbers/{number}": {
    "number": {
      "path": "/angel-numbers/numbers",
      "limit": 50,
      "lang": true
    }
  },
  "GET /astrology/planet-meanings/{id}": {
    "id": {
      "path": "/astrology/planet-meanings",
      "lang": true
    }
  },
  "GET /astrology/signs/{id}": {
    "id": {
      "path": "/astrology/signs",
      "lang": true
    }
  },
  "GET /crystals": {
    "color": {
      "path": "/crystals/colors",
      "lang": true
    },
    "planet": {
      "path": "/crystals/planets",
      "lang": true
    }
  },
  "GET /crystals/{id}": {
    "id": {
      "path": "/crystals",
      "limit": 100,
      "lang": true
    }
  },
  "GET /dreams/symbols": {
    "letter": {
      "path": "/dreams/symbols/letters"
    }
  },
  "GET /dreams/symbols/{id}": {
    "id": {
      "path": "/dreams/symbols",
      "search": "q",
      "limit": 50
    }
  },
  "GET /iching/trigrams/{id}": {
    "id": {
      "path": "/iching/trigrams",
      "lang": true
    }
  },
  "GET /tarot/cards/{id}": {
    "id": {
      "path": "/tarot/cards",
      "limit": 100,
      "lang": true
    }
  }
};

/** `METHOD /path` of a bound operation -> request field -> the other field and value that disable it. */
export const DISABLED_WHEN: Record<string, Record<string, FieldCondition>> = {
  "GET /tarot/cards": {
    "suit": {
      "field": "arcana",
      "value": "major"
    }
  }
};
